import React from "react";
//#region types
import { BaseFormFieldProps } from "models/propTypes/wintFormPropsTypes";
//#endregion
//#region components
import { FormControl } from "@mui/material";
import SimpleTimePicker from "../../datePickers/simpleTimePicker";
//#endregion
import cssExports from "theme/styles/main.module.scss";

interface TimeInputProps extends BaseFormFieldProps {
  label?: string | React.ReactElement;
  className?: string;
}

const TimeInput: React.FC<TimeInputProps> = (props) => {
  const onChange = (time?: string) => {
    props.setValue(time || undefined);
  };

  return (
    <FormControl fullWidth className={cssExports.inputFormControl}>
      <SimpleTimePicker
        disabled={props.disabled}
        label={props.label}
        value={props.value}
        error={props.hasError}
        name={props.name}
        onChange={onChange}
        onBlur={props.onBlur}
        className={props.className}
        data-testid={`${props.name}TimeInput`}
      />
    </FormControl>
  );
};

export default TimeInput;

